import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

/* eslint-disable camelcase */
export type TranslationTask = {
  task_key: string;
  status: string;
  created_at: string;
  updated_at: string;
  payload: {
    target_locale_id: number;
    source_locale_id: number;
    content_id: string;
    user_id: string;
    type: string;
    artist_id: string;
    content_media_type: string;
  };
  content?: {
    id: string;
    title: string | null;
    // false when the content is soft-deleted (still listed, flagged unavailable).
    is_available: boolean;
  };
  artist?: {
    id: string | null;
    name: string | null;
    // false when the artist is deleted (destroyed) — same condition as the Studio artist selector.
    is_available: boolean;
  };
  locale?: {
    locale: string;
    label: string;
    icon_url?: string;
  };
  error?: {
    message: string;
  };
};

export type TranslationTasksResponse = PaginatedListResponse<TranslationTask>;

export type GetTranslationTasksParams = {
  limit?: number;
  status?: string | null;
  artistId?: string | null;
  type?: string | null;
  // Opaque pagination cursor returned as `last_item_identifier`; pass back verbatim.
  offset?: string | null;
};

/**
 * Get translation tasks
 * @param params - The parameters for the request
 * @returns The translation tasks
 */
export async function getTranslationTasks({
  limit = 20,
  status = null,
  artistId = null,
  type = null,
  offset = null,
}: GetTranslationTasksParams = {}): Promise<TranslationTasksResponse> {
  const params: Record<string, string | number> = { limit };

  if (status) params.status = status;
  if (artistId) params.artist_id = artistId;
  if (type) params.type = type;
  if (offset) params.offset = offset;

  const url = `/web/studio/queues/tasks`;
  const response = await api.executeGetRequest<TranslationTasksResponse>(url, params);

  return response.data;
}
